import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SupportButton from '../support/SupportButton';
import Tabs from '../shared/Tabs';
import { pipelinesTabs, pipelinesTabPath } from './pipelinesTabs';

// THE PIPELINES PAGE HEADER — title + Support, the line under it, any actions on the right, and the
// Hotels | Pipeline Templates | Logs bar. On the Pipelines page and on every page opened from it (one hotel's pipeline,
// a pipeline template), so the user never leaves the bar they clicked from: `tab` is the one lit.
//
//   title       default 'Pipelines'
//   subtitle    the line under the title
//   support     the SupportButton context (object or function) — drawn only on a page with no bar (`tab` omitted):
//               with the bar, support is its Support tab
//   actions     rendered on the right (Back, New Pipeline Template)
//   tab         the lit tab; omitted, no bar is drawn
//   onTabChange default: go to that tab of the Pipelines page — what a page opened from it wants
export default function PipelinesHeader({ title = 'Pipelines', subtitle, support, actions, tab, onTabChange }) {
    const navigate = useNavigate();
    const { isSuperAdmin } = useAuth();
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem', marginBottom: '1.5rem' }}>
                <div>
                    <h1 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#1e293b', margin: '0 0 0.5rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                        {title}
                        {support && !tab && <SupportButton context={support} />}
                    </h1>
                    {subtitle && <p style={{ color: '#6b7280', margin: 0 }}>{subtitle}</p>}
                </div>
                {actions}
            </div>
            {tab && (
                <div style={{ marginBottom: '1.25rem' }}>
                    <Tabs tabs={pipelinesTabs(isSuperAdmin)} active={tab}
                        onChange={onTabChange || ((t) => navigate(pipelinesTabPath(t)))} />
                </div>
            )}
        </>
    );
}
